import React, { useEffect, useState } from "react";
import {
  Box,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { HeroSection } from "../utils/home/hero-section";
import { LiveRacesSection } from "../utils/home/live-races-section";
import { ChatSection } from "../utils/home/chat-section";
import { UserProfile } from "../utils/home/user-profile";
import englishTranslations from "../../i18n/translations/en";
import GradientButton from "../utils/gradient-button";
import { assetIcons, assetImages } from "../../constants/assets";
import FindMatchButton from "../utils/home/find-match-button";
import FindingMatchButton from "../utils/home/finding-match-button";
import LoadingModal from "../utils/popups/match-info-popup";
import { useNavigate } from "react-router-dom";
import routes from "../../constants/routes";
import MatchFinder from "../utils/finding-match-timer";
import apiRoutes from "../../api/routes";
import useApiRequest from "../../api/api";
import { formatStreamDuration, formatTimeToHHMM } from "../utils/format/time";
import LoadingBackdrop from "../utils/loader";
import LiveRacesPageSkeleton from "./live-games-skeleton";

export default function LiveGamesComponent() {
  const { makeApiCall } = useApiRequest();
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const handleRaceCardClick = (id) => {
    navigate(`/race?id=${id}`);
  };
  const handleNavigateToRace = (id) => {
    navigate(`${routes.race}?id=${id}`);

    // Perform navigation or additional logic if required
  };
  const [races, setRaces] = useState([]);
  const fetchRaces = async () => {
    setIsLoading(true);

    try {
      const response = await makeApiCall(apiRoutes.races.list, "GET");
      if (response?.data) {
        const mappedRaces = response.data.map((race) => ({
          id: race.identifier, // Map the 'identifier' as 'id'
          title: race.name, // Map the 'name' as 'title'
          startTime: race.startTime, // Store startTime for future updates
          runners: `${race.racers.length} `, // Calculate the number of runners
          backgroundImage: race.imageUrl, // Map 'imageUrl' to 'backgroundImage'
        }));

        // Set the mapped races to the state
        setRaces(mappedRaces);
      }
    } catch (error) {
      console.error("Failed to fetch races:", error);
    } finally {
    }
  };

  const updateRaceTimes = () => {
    setRaces((prevRaces) =>
      prevRaces.map((race) => ({
        ...race,
        time: formatStreamDuration(race.startTime), // Update the time for each race
      }))
    );
    setIsLoading(false);
  };

  useEffect(() => {
    fetchRaces();

    // Set an interval to update the race times every second
    const intervalId = setInterval(updateRaceTimes, 1000);

    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      {isLoading ? (
        <LiveRacesPageSkeleton isMediumScreen={isMediumScreen} />
      ) : (
        <Box
          sx={{
            display: "flex",
            height: "100vh",
          }}
        >
          {/* <LoadingBackdrop isLoading={isLoading} /> */}

          {/* Left side - scrollable content */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              p: isMediumScreen ? 2.5 : "15px",
              pt: isMediumScreen ? "15px" : "38px",
              pl: isMediumScreen ? "auto" : "38px",
              height: "auto",
              mb: 2,
              // mt: 4,
              "&::-webkit-scrollbar": {
                display: "none", // Hide scrollbar in WebKit browsers (Chrome, Safari)
              },
            }}
          >
            <Box mt={2}>
              <LiveRacesSection
                races={races}
                onClick={handleRaceCardClick}
                showSeeMore={false}
              />
            </Box>
          </Box>

          {/* Right side - fixed content */}
          {!isMediumScreen && (
            <Box
              sx={{
                width: { lg: 370, sm: 300 },
                p: 3,
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none", // Hide scrollbar in WebKit browsers (Chrome, Safari)
                },
              }}
            >
              <UserProfile />
              <Box mt={3}></Box>
              <ChatSection />

              {/* Find Random Match Button */}
              <Box
                display={"flex"}
                justifyContent={"left"}
                mt={2}
                sx={{ mb: 11 }}
              >
                <MatchFinder
                  onNavigate={handleNavigateToRace} // Custom navigation logic
                />
              </Box>
            </Box>
          )}
        </Box>
      )}
    </>
  );
}
